import PrimaryNavigationItem from './PrimaryNavigationItem';
import PrimaryNavigation from './PrimaryNavigation';
import PrimaryNavigationButton from './PrimaryNavigationButton';

PrimaryNavigation.Item = PrimaryNavigationItem;
PrimaryNavigation.Button = PrimaryNavigationButton;

export default PrimaryNavigation;
